import BoxImage from "@components/BoxImage";
import ButtonContainer from "@components/ButtonContainer";
import Player from "@components/Player";
import { timestampToString } from "@helpers/dates.format";
import { IWebinar } from "@interfaces/webinar";
import { ReactElement } from "react";
import { Col } from "reactstrap";

interface IDetailForm {
  data: IWebinar;
}

const DetailForm = ({ data }: IDetailForm): ReactElement => (
  <form className="form">
    <Col md={6}>
      <div className="form__form-group">
        <span className="form__form-group-label">Title</span>
        <div className="form__form-group-field">
          <input type="text" value={data?.title} disabled />
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">Date</span>
        <div className="form__form-group-field">
          <input type="text" value={timestampToString(data?.date)} disabled />
        </div>
      </div>

      <BoxImage title="Thumbnail" urlImage={data?.thumbnailUrl} />
    </Col>
    <Col md={6}>
      <Player title="Video" media={data?.mediaUrl} />
    </Col>

    <ButtonContainer />
  </form>
);

export default DetailForm;
